import { assoc, prop, reduce } from "ramda";
import type { DefaultRootState } from "react-redux";
import { createSelector } from "reselect";
import { pluckEntityStores } from "helpers/transforms/entities";

const contextSelector = (state: DefaultRootState) => state.context;

const entitiesSelector = createSelector(contextSelector, prop("entities"));

const locationGroupsSelector = createSelector(
  contextSelector,
  prop("locationGroups")
);

const featureFlagsSelector = createSelector(
  contextSelector,
  prop("featureFlags")
);

const toolbarSnackSelector = createSelector(
  contextSelector,
  prop("toolbarSnacks")
);

const storeNamesSelector = createSelector(entitiesSelector, (entities) => {
  const stores = pluckEntityStores(entities);
  return reduce(
    (acc, { id, name }) => assoc(id, name, acc),
    {} as Record<string, string>,
    stores
  );
});

export {
  contextSelector,
  entitiesSelector,
  featureFlagsSelector,
  locationGroupsSelector,
  storeNamesSelector,
  toolbarSnackSelector,
};
